export default "__VITE_ASSET___GS9FVrP__"